module.exports = __webpack_public_path__ + "img/grey_curve.e7d7e270.png";